import React from 'react';
import FundingCommissionStatusBadge from './FundingCommissionStatusBadge';

const formatCurrency = (value) => {
  if (value == null || value === '') return '—';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 }).format(value);
};

const formatDate = (value) => {
  if (!value) return '—';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '—';
  return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
};

const FundingCommissionCard = ({ commission, onSelect }) => {
  if (!commission) return null;

  return (
    <button
      type="button"
      onClick={() => onSelect?.(commission)}
      className="w-full rounded-xl border border-[var(--fg-line)] bg-white p-4 text-left dark:bg-slate-950/20"
    >
      <div className="flex items-start justify-between gap-2">
        <div>
          <div className="font-medium text-[var(--fg-text)]">{commission.clientName}</div>
          <div className="text-xs text-[var(--fg-muted)]">{commission.lenderName} · {commission.productType}</div>
        </div>
        <FundingCommissionStatusBadge status={commission.status} />
      </div>
      <div className="mt-3 grid grid-cols-2 gap-2 text-xs">
        <div>
          <div className="text-[var(--fg-muted)]">Funded</div>
          <div className="font-medium">{formatCurrency(commission.fundedAmount)}</div>
        </div>
        <div>
          <div className="text-[var(--fg-muted)]">Commission</div>
          <div className="font-medium text-[var(--fg-accent)]">{formatCurrency(commission.commissionAmount)}</div>
        </div>
        <div>
          <div className="text-[var(--fg-muted)]">Payout</div>
          <div>{commission.payoutStatus || '—'}</div>
        </div>
        <div>
          <div className="text-[var(--fg-muted)]">Due</div>
          <div>{formatDate(commission.payoutDueAt)}</div>
        </div>
      </div>
    </button>
  );
};

export default FundingCommissionCard;
